import currencyService from '@/services/api/currencies.services'

const actions = {
    getCurrencies() {
        return new Promise((resolve, reject) => {
            currencyService
                .get()
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

export default {
    namespaced: true,
    actions,
}
